import React from 'react';
import ProjectIcon from './icons/ProjectIcon';
import { FloatingButton } from '../styles/SwitchBoardButton.styles';

const SwitchBoardButton = ({ onClick }) => {
    return (
        <FloatingButton onClick={onClick} data-testid="switch-board-button">
            <ProjectIcon />
            Switch board
        </FloatingButton>
    );
};

export default SwitchBoardButton;
